module.exports = __webpack_public_path__ + "static/img/jjc_honor2.0693cf6d.png";